import { createAction } from 'redux-act';

export const updateQuery = createAction('search/UPDATE_QUERY');
export const clearFilters = createAction('search/CLEAR_FILTERS');
export const setLoading = createAction('search/SET_LOADING');
export const clearResults = createAction('search/CLEAR_RESULTS');
export const fetchSearchResults = createAction('search/FETCH_SEARCH_RESULTS');
export const cancelFetchSearchResults = createAction('search/CANCEL_FETCH_SEARCH_RESULTS');
export const fetchSearchResultsSuccess = createAction('search/FETCH_SEARCH_RESULTS_SUCCESS');
export const fetchSearchResultsFailure = createAction('search/FETCH_SEARCH_RESULTS_FAILURE');
export const routeToProperty = createAction('search/ROUTE_TO_PROPERTY');
export const mapPropertyMarkerClick = createAction('search/MAP_PROPERTY_MARKER_CLICK');
export const mapRedoSearchClick = createAction('search/MAP_REDO_SEARCH_CLICK');
